import styled from 'styled-components';

export const CandidateScheduleWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
`;

export const SelectedDatesSection = styled.div`
  margin-bottom: 30px;

  h5 {
    margin-bottom: 15px;
    color: #333;
    font-weight: 600;
  }
`;

export const AvailableDatesSection = styled.div`
  h5 {
    margin-bottom: 15px;
    color: #333;
    font-weight: 600;
  }
`;

export const DateItemWrapper = styled.div`
  background-color: ${(props) => props.backgroundColor || 'rgb(255, 255, 255)'};
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 8px;
  padding: 15px;
  cursor: ${(props) => (props.isClickable ? 'pointer' : 'default')};
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background-color: ${(props) => (props.isClickable ? '#f5f5f5' : props.backgroundColor)};
    transform: ${(props) => (props.isClickable ? 'translateY(-2px)' : 'none')};
    box-shadow: ${(props) => (props.isClickable ? '0 4px 8px rgba(0,0,0,0.1)' : 'none')};
  }

  .date-content {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .ordinal-number {
    font-weight: 700;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 60px;
    margin-right: 15px;
    color: #fff;
    font-size: 0.9em;
  }

  .date-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    color: ${(props) => (props.backgroundColor === 'rgb(64, 64, 64)' ? '#fff' : '#000')};
  }

  .date-display {
    font-size: 0.9em;
    margin-bottom: 5px;
  }

  .mobile_display {
    display: block;

    @media (min-width: 768px) {
      display: none;
    }
  }

  .browser_display {
    display: none;

    @media (min-width: 768px) {
      display: block;
    }
  }

  .date-label {
    font-size: 0.9em;
    font-weight: 500;
  }

  .drag-handle {
    display: flex;
    width: 50px;
    height: 50px;
    justify-content: center;
    align-items: center;
    cursor: grab;

    &:active {
      cursor: grabbing;
    }

    .move-icon {
      width: 25px;
      height: 25px;
      opacity: 0.7;
    }
  }

  @media (max-width: 767px) {
    .ordinal-number {
      width: 50px;
      margin-right: 10px;
    }

    .drag-handle {
      width: 40px;
      height: 40px;

      .move-icon {
        width: 20px;
        height: 20px;
      }
    }
  }
`;

export const DraggableItemWrapper = styled(DateItemWrapper)`
  background-color: rgb(64, 64, 64);
  color: #fff;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px 0px;

  &:hover {
    background-color: rgb(64, 64, 64);
  }
`;
